import { GetAllTemplateEvent, GetAllTemplateResult } from 'bloggers-backend/lib/templates/domain/domain';
import { GridColDef } from '@mui/x-data-grid';
import { Button } from '@mui/material';
import { Box } from '@mui/system';
import * as React from 'react';
import { useNavigate, Link } from 'react-router-dom';

import Grid, { QueryOptions } from './Grid';
import { AppContext } from '../AppContext';


const columns: GridColDef[] = [
  {
    field: 'name',
    headerName: 'name',
    filterable: true,
    sortable: true,
    renderCell: ({row}: any) => (<Link to={`/templates/${row?.id}`}>{row?.name}</Link>)
  },
  { field: 'title', width: 150, filterable: true, sortable: true },
  { field: 'tags', width: 150, filterable: true },
  { field: 'access', width: 150, filterable: true, sortable: true },
  { field: 'date', width: 150, filterable: true, sortable: true },
  { field: 'text', width: 150, filterable: true, sortable: true },
  { field: 'creator.name', headerName: 'creator', width: 150, filterable: true, sortable: true, valueGetter: (_value, row) => row?.creator?.name },
];

export function TemplatesPage() {
  const {client, notificationsService} = React.useContext(AppContext);

  const navigate = useNavigate();

  const fetchData = async (options: QueryOptions) => {
    const result = await client<GetAllTemplateEvent, GetAllTemplateResult>({
      event: 'getAllTemplates',
      data: options as any
    })

    if (result.success) {
      return result.value
    } else {
      notificationsService.notify({
        severity: 'error',
        message: `Error: ${JSON.stringify(result.errors)}`
      });

      return {data: [], pageInfo: {}}
    }
  };

  return <Box sx={{display: 'flex', flexDirection: 'column', height: '100%' }}>
    <Box sx={{marginBottom: 1}}>
      <Button
        variant="contained"
        onClick={() => navigate('/templates/new')}
      >
        Create new template
      </Button>
    </Box>
    <Box sx={{flexGrow: 1}}>
      <Grid
        columns={columns}
        cacheName={'templates'}
        fetchData={fetchData}
        onRowClick={(id) => {}}
        bulkDelete={{event: 'templates.deleteMany', deleteWhat: 'templates'}}
      />
    </Box>
  </Box>
}